import { Input } from "antd";
import { FiSearch } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import "./Search_Header.scss";

function Search_Header() {
  const [searchValue, setSearchValue] = useState("");
  const navigate = useNavigate();

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      navigate(`/products?q=${encodeURIComponent(searchValue)}`);
    }
  };

  return (
    <div className="inner-search">
      <Input
        variant="borderless"
        allowClear
        prefix={<FiSearch />}
        className="inner-search-header"
        placeholder="Tìm kiếm sản phẩm, thương hiệu hoặc kiểu dáng..."
        value={searchValue}
        onChange={(e) => setSearchValue(e.target.value)}
        onKeyDown={handleKeyPress}
      />
    </div>
  );
}

export default Search_Header;
